import { ApiClient } from "@erc/shared";
import env from "../env";
import { getToken } from "./auth";

export const apiClient = new ApiClient(env.API_URL);

export function refreshApiToken() {
  const token = getToken();
  apiClient.setToken(token);
}

// Uygulama başladığında token'ı set et
refreshApiToken();
